import shouldForwardProp from "@styled-system/should-forward-prop";

import {
  color,
  ColorProps,
  compose,
  display,
  DisplayProps,
  EmotionComponent,
  hideVisually,
  layout,
  LayoutProps,
  OverrideNativeElementProps,
  position,
  PositionProps,
  size,
  SizeProps,
  space,
  SpaceProps,
  styled,
  textStyle,
  TextStyleProps,
  themeGet,
  typography,
  TypographyProps,
} from "@catchoftheday/theme";

const customProps = compose(
  space,
  display,
  layout,
  position,
  color,
  typography,
  size
);

type CustomLabelProps = {
  /** Indicates if the label is for a required input */
  required?: boolean;
};

export type LabelProps = OverrideNativeElementProps<
  CustomLabelProps &
    SpaceProps &
    TextStyleProps &
    DisplayProps &
    LayoutProps &
    PositionProps &
    ColorProps &
    TypographyProps &
    SizeProps,
  "label"
>;

export const Label: EmotionComponent<LabelProps> = styled("label", {
  shouldForwardProp,
})<LabelProps>`
  ${textStyle}
  ${customProps}
  ${(props) => props.hidden && hideVisually()}
  ${(props) =>
    props.required &&
    `
    ::after {
        content: "*";
        display: inline;
        margin-left: 2px;
        color: ${themeGet("colors.ui.error")(props)};
    }
  `}
`;

Label.defaultProps = {
  textStyle: "label",
  m: 0,
  mb: 3,
  hidden: false,
  display: "block",
  width: "100%",
  required: false,
};

Label.displayName = "Label";

export default Label;
